import { render, staticRenderFns } from "./vdFooter.vue?vue&type=template&id=716dcbce&scoped=true&"
import script from "./vdFooter.vue?vue&type=script&lang=js&"
export * from "./vdFooter.vue?vue&type=script&lang=js&"
import style0 from "./vdFooter.vue?vue&type=style&index=0&id=716dcbce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../hastrid-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716dcbce",
  null
  
)

export default component.exports